import { z } from "zod";

export const createCancelRequestSchema = (requestCode: string) => {
  const requestCodeWithoutHyphens = requestCode.replace(/-/g, "");

  return z.object({
    requestNumber: z
      .string()
      .min(1, "El número de solicitud es obligatorio")
      .transform((val) => val.toUpperCase())
      .refine((val) => {
        return val.trim().length > 0;
      }, "El número de solicitud no puede estar vacío")
      .refine(
        (val) => val.replace(/-/g, "") === requestCodeWithoutHyphens,
        `El número de solicitud debe coincidir con ${requestCode} (sin guiones)`,
      ),
    cancellationReason: z
      .string()
      .min(1, "El motivo de cancelación es obligatorio")
      .max(2000, "El motivo no puede exceder los 2000 caracteres")
      .refine((val) => {
        return val.trim().length > 0;
      }, "El motivo de cancelación no puede estar vacío"),
  });
};

export type CancelRequestFormData = z.infer<
  ReturnType<typeof createCancelRequestSchema>
>;
